import { getToApi, postToApi, patchToApi } from './axios';

const qs = (params) => {
  const sp = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') sp.append(k, v);
  });
  const s = sp.toString();
  return s ? `?${s}` : '';
};

export const listTickets = (params) => getToApi(`/tickets${qs(params)}`);
export const countsTickets = (params) => getToApi(`/tickets/counts${qs(params)}`);
export const getTicket = (id) => getToApi(`/tickets/${id}`);
export const createTicket = (body) => postToApi('/tickets', body).then((r) => r.data);
// PATCH: putToApi no propaga method override (axios.put fija method:'put' via valueFromConfig2).
// Se usa patchToApi (helper dedicado en axios.js, mismo patrón que putToApi pero axios.patch).
export const updateTicket = (id, body) => patchToApi(`/tickets/${id}`, body).then((r) => r.data);

// Descarga del .xlsx (getToApi devuelve result.data; con responseType:'blob' es el Blob).
export const exportTicketsXlsx = async (params) => {
  const blob = await getToApi(`/exports/tickets${qs(params)}`, { responseType: 'blob' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'tickets.xlsx';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
